import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import HelpSidebar from './HelpSidebar'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    height: '100vh',
    background: 'var(--color-white)',
    color: 'var(--color-neutral-900)'
  },
  sidebar: {
    width: 280,
    minWidth: 280,
    borderRight: '1px solid var(--color-neutral-300)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  content: {
    flex: 1,
    overflow: 'auto',
    padding: 'var(--dim-5)',
    minWidth: 0
  }
}))

function HelpLayout ({ children }) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.sidebar}>
        <HelpSidebar />
      </div>
      <div className={classes.content}>
        {children}
      </div>
    </div>
  )
}

HelpLayout.propTypes = {
  children: PropTypes.node
}

export default HelpLayout
